// Hostnames whose first DNS label is NOT a tenant subdomain:
//   backoffice — the platform admin host;
//   app        — app.f2core.com, the one address notification links point at;
//   account    — the older shared sign-in host;
//   www        — the marketing host.
// flex2-api treats "app" and "account" as common login domains: signing in
// there lands the user in their primary organization and the login response
// returns its subdomain as userDetails.overrideSubdomain, which is stored in
// localStorage._subdomain. On these hosts that stored tenant must win, or
// every request after login would carry "app" and flex2-api would refuse it.
// Before login (nothing stored) the host label is still sent, so the API sees
// "app"/"account" and applies the common-domain login.
//
// The common login domains are fixed in flex2-api at
// Utility.Constants.Subdomains.CommonLogin (also reserved there, so no
// organization can take one). This set must include every entry of that list.
//
// Deliberately dependency-free: imported by both src/api/index.js and
// src/helpers/axiosConfig.js, which sit inside the api ↔ store ↔ helpers
// import cycle. Keeping this module out of that cycle avoids a TDZ crash
// when setAxios() runs during store bootstrap.
export const NON_TENANT_SUBDOMAINS = new Set(["backoffice", "app", "account", "www"]);

// The host's first DNS label, or null for a bare two-part hostname.
export function hostSubdomainOf(hostname) {
  const parts = (hostname || "").split(".");
  return parts.length > 2 ? parts[0] : null;
}

// The `_subdomain` header for a request from a host whose first label is
// `hostSubdomain` (null for a bare domain), given the tenant stored from the
// login response. Returns null when there is nothing to send.
export function resolveTenantSubdomain(hostSubdomain, storedSubdomain) {
  if (storedSubdomain && (!hostSubdomain || NON_TENANT_SUBDOMAINS.has(hostSubdomain))) {
    return storedSubdomain;
  }
  return hostSubdomain || null;
}
